module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-requests-list text-dark",
    class: {
      'user-requests-list--user': _vm.isUserView
    }
  }, [(!_vm.isUserView) ? _c('h1', [_vm._v("Fraværsanmodninger")]) : _vm._e(), _vm._v(" "), _c('Tabs', {
    staticClass: "marg-1-bottom",
    attrs: {
      "selected": _vm.selectedTab,
      "tabs": _vm.tabs
    },
    on: {
      "select": function($event) {
        _vm.selectedTab = $event
      }
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : _c('table', {
    staticClass: "do-table"
  }, [_c('thead', {
    staticClass: "do-table__header"
  }, [_c('th', {
    staticClass: "td-created"
  }, [_vm._v("Oprettet")]), _vm._v(" "), _c('th', [_vm._v("Hvem")]), _vm._v(" "), _c('th', {
    staticClass: "td-date"
  }, [_vm._v("Fra")]), _vm._v(" "), _c('th', {
    staticClass: "td-date"
  }, [_vm._v("Til")]), _vm._v(" "), _c('th', [_vm._v("Årsag")]), _vm._v(" "), _c('th', [_vm._v("Note")]), _vm._v(" "), (_vm.selectedTab !== 'requested') ? _c('th', [_vm._v("Note tilbage")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab !== 'requested') ? _c('th', [_vm._v("Besvaret af")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.selectedTab === 'requested' ? '' : 'Status'))])]), _vm._v(" "), _c('tbody', [(_vm.sortedRequests.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic text-align-left",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.emptyTableTitle) + "\n      ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedRequests), function(request) {
    return _c('tr', {
      key: request.id,
      on: {
        "click": function($event) {
          return _vm.setTheEditRequest(request)
        }
      }
    }, [_c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
      }],
      staticClass: "td-created",
      attrs: {
        "content": request.vCreated
      }
    }, [_vm._v(_vm._s(request.vCreatedTimeAgo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.vUserName))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(request.vStart))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(request.vEnd))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "do-pill do-pill--white"
    }, [_vm._v(_vm._s(request.vSubjectTitle))])]), _vm._v(" "), _c('td', {
      staticClass: "italic"
    }, [_vm._v(_vm._s(request.request_note))]), _vm._v(" "), (_vm.selectedTab !== 'requested') ? _c('td', {
      staticClass: "italic"
    }, [_vm._v(_vm._s(request.response_note))]) : _vm._e(), _vm._v(" "), (_vm.selectedTab !== 'requested') ? _c('td', [_vm._v(_vm._s(request.vResponderName))]) : _vm._e(), _vm._v(" "), _c('td', [(!_vm.isUserView && _vm.selectedTab === 'requested') ? _c('button', {
      staticClass: "do-bttn",
      on: {
        "click": function($event) {
          _vm.theAnswerRequest = request
        }
      }
    }, [_vm._v("\n          Besvar\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isUserView && request.state === 'requested') ? _c('div', {
      staticClass: "d-bagde d-badge--yellow"
    }, [_vm._v("Afventer svar")]) : (request.state === 'approved') ? _c('div', {
      staticClass: "d-bagde d-badge--green"
    }, [_vm._v("Godkendt")]) : _vm._e(), _vm._v(" "), (request.state === 'rejected') ? _c('div', {
      staticClass: "d-bagde"
    }, [_vm._v("Afvist")]) : _vm._e()])])
  })], 2)]), _vm._v(" "), (_vm.theAnswerRequest) ? _c('UserRequestListAnswer', {
    attrs: {
      "request": _vm.theAnswerRequest
    },
    on: {
      "submitted": _vm.onSubmittedAnswer,
      "close": function($event) {
        _vm.theAnswerRequest = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theEditRequest) ? _c('UserRequestForm', {
    attrs: {
      "editRequest": _vm.theEditRequest
    },
    on: {
      "submitted": _vm.onSubmittedAnswer,
      "close": function($event) {
        _vm.theEditRequest = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47649dd9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserRequests/UserRequestList.vue
// module id = 1618
// module chunks = 1